(() => {
  const slideshows = [...document.querySelectorAll('[data-prize-slideshow]')];
  if (!slideshows.length) return;

  function showPrize(index) {
    slideshows.forEach(slideshow => {
      slideshow.querySelectorAll('[data-prize-slide]').forEach(slide => {
        const active = Number(slide.dataset.prizeSlide) === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      slideshow.querySelectorAll('[data-prize-index]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.prizeIndex) === index));
      });
    });
  }

  slideshows.forEach(slideshow => {
    slideshow.querySelectorAll('[data-prize-index]').forEach(button => {
      button.addEventListener('click', () => showPrize(Number(button.dataset.prizeIndex)));
    });
    slideshow.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const next = event.key === 'ArrowRight' ? 1 : 0;
      showPrize(next);
      slideshow.querySelector(`[data-prize-index="${next}"]`)?.focus();
    });
  });
})();
